










import { Component } from 'vue-property-decorator';

import BuyboxFeatureComponent from './BuyboxFeatureComponent';

import BuyNowButton from '@/components/BuyNowButton.vue';

@Component({
  components: {
    BuyNowButton,
  },
  props: {
    quantity: {
      type: Number,
      required: true,
    },
  },
})
export default class BuyNowFeature extends BuyboxFeatureComponent { }

